import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import Notifications from '@kyvg/vue3-notification';
import './css/tailwind.css';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import Button from 'primevue/button';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import 'primeicons/primeicons.css';
import Carousel from 'primevue/carousel';
import Stepper from 'primevue/stepper';
import StepList from 'primevue/steplist';
import StepPanels from 'primevue/steppanels';
import StepItem from 'primevue/stepitem';
import Step from 'primevue/step';
import StepPanel from 'primevue/steppanel';
import MegaMenu from 'primevue/megamenu';
import InputGroup from 'primevue/inputgroup';
import IftaLabel from 'primevue/iftalabel';
import InputText from 'primevue/inputtext';
import Drawer from 'primevue/drawer';
import Image from 'primevue/image';

import RadioButton from 'primevue/radiobutton';
import RadioButtonGroup from 'primevue/radiobuttongroup';
import Checkbox from 'primevue/checkbox';
import ProgressSpinner from 'primevue/progressspinner';
import Card from 'primevue/card';
import Menubar from 'primevue/menubar';
import FloatLabel from 'primevue/floatlabel';
import Dialog from 'primevue/dialog';
import Vue3TouchEvents, {
  type Vue3TouchEventsOptions,
} from 'vue3-touch-events';

createApp(App)
  .use(store)
  .use(router)
  .use<Vue3TouchEventsOptions>(Vue3TouchEvents, {
    disableClick: false,
  })
  .use(Notifications)
  .use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: '.dark',
      },
    },
  })
  .use(ToastService)
  .use(ConfirmationService)
  .component('Checkbox', Checkbox)
  .component('Menubar', Menubar)
  .component('Card', Card)
  .component('RadioButton', RadioButton)
  .component('RadioButtonGroup', RadioButtonGroup)
  .component('ProgressSpinner', ProgressSpinner)
  .component('IftaLabel', IftaLabel)
  .component('Dialog', Dialog)
  .component('Button', Button)
  .component('Carousel', Carousel)
  .component('Image', Image)
  .component('MegaMenu', MegaMenu)
  .component('InputGroup', InputGroup)
  .component('FloatLabel', FloatLabel)
  .component('InputText', InputText)
  .component('Drawer', Drawer)
  .component('Stepper', Stepper)
  .component('StepList', StepList)
  .component('StepPanels', StepPanels)
  .component('StepItem', StepItem)
  .component('Step', Step)
  .component('StepPanel', StepPanel)
  .mount('#app');
